<template>
  <footer id="footer">
    <div class="footer-top">
      <div class="container">
        <div class="footer-grid">

          <div class="footer-brand">
            <a
              href="/home"
              class="footer-logo-wrap"
            ><img
              src="/minds-academy-lockup.png"
              alt="Minds' Academy"
              class="footer-logo"
            ></a>
            <p>{{ $t('home.footer.tagline') }}</p>
          </div>

          <div class="footer-col">
            <h4>{{ $t('home.footer.demosTitle') }}</h4>
            <ul>
              <li><a href="/demos?profil=etudiant">{{ $t('home.footer.demosStudent') }}</a></li>
              <li><a href="/demos?profil=enseignant">{{ $t('home.footer.demosTeacher') }}</a></li>
              <li><a href="/phototheque">Photothèque</a></li>
            </ul>
          </div>

          <div class="footer-col">
            <h4>{{ $t('home.footer.supportTitle') }}</h4>
            <ul>
              <li><a href="/home#faq">{{ $t('nav.faq') }}</a></li>
              <li><a
                href="/contact"
                @click.prevent="$router.push('/contact')"
              >{{ $t('nav.contact') }}</a></li>
            </ul>
          </div>

          <div class="footer-col">
            <h4>{{ $t('home.footer.followUs') }}</h4>
            <div class="social-links">
              <a
                href="https://www.facebook.com/Mindsacademy13"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i class="bx bxl-facebook" />
              </a>
              <a
                href="https://www.instagram.com/mindsacademy13/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i class="bx bxl-instagram" />
              </a>
              <a
                href="https://wa.me/21695624160"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <i class="bx bxl-whatsapp" />
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container">
        <div class="footer-bottom-main">
          <span>{{ $t('footer.rights') }}</span>
          <span class="footer-legal">
            <a
              href="/politique-confidentialite"
              @click.prevent="$router.push('/politique-confidentialite')"
            >{{ $t('legal.privacy.link') }}</a> · <a
              href="/cgu"
              @click.prevent="$router.push('/cgu')"
            >{{ $t('legal.terms.link') }}</a>
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter',
  computed: {
    registrationEnabled() {
      return process.env.VUE_APP_REGISTRATION_ENABLED === 'true'
    },
  },
}
</script>

<style scoped>
#footer {
  font-size: 14px;
}

.footer-top {
  padding: 60px 0 40px;
  background:
    radial-gradient(900px 420px at 50% 0%, rgba(255, 111, 89, 0.12) 0%, rgba(255, 255, 255, 0) 62%),
    linear-gradient(180deg, var(--bg-sky-strong) 0%, #ffffff 100%);
  border-top: 1px solid rgba(255, 111, 89, 0.32);
}

.footer-top .container {
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  gap: 40px;
}

@media (max-width: 768px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}

.footer-brand {
  padding-right: 20px;
}

.footer-logo-wrap {
  display: inline-flex;
  align-items: center;
  margin-bottom: 16px;
  background: none;
  border: 0;
  box-shadow: none;
  padding: 0;
}
.footer-logo {
  display: block;
  width: auto;
  max-height: 52px;
  mix-blend-mode: multiply;
}

.footer-brand p {
  font-size: 14px;
  color: var(--muted);
  line-height: 1.7;
  margin: 0;
}

.footer-col h4 {
  font-size: 15px;
  font-weight: 700;
  color: #0b1220;
  margin-bottom: 16px;
}

.footer-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-col ul li {
  padding: 5px 0;
}

.footer-col ul a {
  color: var(--muted);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.footer-col ul a:hover {
  color: var(--brand-blue);
}

.social-links {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}

.social-links a {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--brand-blue);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  text-decoration: none;
  transition: background 0.2s, transform 0.2s;
}

.social-links a:hover {
  background: var(--brand-blue-deep);
  transform: translateY(-2px);
}

.footer-bottom {
  padding: 20px 0;
  background: #ffffff;
  border-top: 1px solid rgba(15, 23, 42, 0.08);
}

.footer-bottom .container {
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.footer-bottom-main {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

@media (max-width: 768px) {
  .footer-bottom-main {
    flex-direction: column;
    text-align: center;
  }
}

.footer-address {
  margin: 0;
  text-align: center;
  color: rgba(71, 85, 105, 0.9);
  font-size: 13px;
  line-height: 1.55;
}

.footer-bottom span {
  color: rgba(71, 85, 105, 0.95);
  font-size: 13px;
}

.footer-legal a {
  color: rgba(71, 85, 105, 0.9);
  text-decoration: none;
  transition: color 0.2s;
}

.footer-legal a:hover {
  color: var(--brand-blue);
}
</style>
